import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { SirDashboardPage } from '../components/dashboard'
import { SirDetailPage } from '../components/detail'

export const SirRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<SirDashboardPage />} />
      <Route path="/:appId" element={<SirDetailPage />} />
      <Route path="*" element={<Navigate to="/sir" replace />} />
    </Routes>
  )
}
